import { Box, Grid } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";

import { MedicoParceiroContext } from "../../../../context/MedicoParceiroContext";
import AcademicDegreeVocationalTraningStep from "./AcademicDegreeVocationalTraningStep";
import PersonalAddressDataStep from "./PersonalAddressDataStep";
import TermsDeclarationsStep from "../../MedicoParceiro/steps/TermsDeclarationsStep";
import MedicoParceiroAttachmentDataStep from "./MedicoParceiroAttachmentDataStep";
import BusinessAddressDataStep from "./BusinessAddressDataStep";
import GuideStep from "./GuideStep";
import Steps from "../../../../components/steps/Steps";
import StepDescription from "../../../../components/steps/StepDescription";
import { MedicoParceiroStepForm } from "../../../../config/MedicoParceiroStepForm";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import { ConfirmModalHandle } from "../../../../components/controls/ConfirmModal";
import Controls from "../../../../components/controls/Controls";
import TmpSkeletonLeftPageCustom from "../../../../components/tempo/TmpSkeletonLeftPageCustom/TmpSkeletonLeftPageCustom";
import { AppThemeRequestProvider } from "../../../../context/ThemeRequestContext";

export default function CorpoClinicoSteps() {
  const { state, dispatch, nextStep } = useContext(
    MedicoParceiroContext
  );
  const [currentComponent, setCurrentComponent] = useState(null);
  const modalRef = React.createRef<ConfirmModalHandle>();

  const history = useHistory();

  const onNextClick = () => {
    nextStep();
  };

  const onConfirmModalClick = () => {
    history.push("/home");
  };

  const onToBackClick = () => {
    if (state.CurrentStep === 1) {
      modalRef.current?.handleOpen();
    } else {
      dispatch({
        type: "GO_TO_BACK_STEP",
      });
    }
  };

  const onToFinishClick = () => {
    nextStep();
  };

  const alertUser = (event: any) => {
    event.returnValue =
      "Você tem certeza que deseja sair do formulário ? Todas as suas informações serão perdidas.";
    event.preventDefault();
  };

  useEffect(() => {

    dispatch({
      type: "RESET_STATE",
    });

    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [dispatch]);

  useEffect(() => {
    if (state.Protocol !== "") {
      history.push({
        pathname: "/protocolo",
        state: {
          protocol: state.Protocol,
        },
      });
    } else {
      let component: any = null;

      window.scrollTo(0, 0);

      let mainStep = MedicoParceiroStepForm.find(
        (c) => c.key === state.CurrentStep
      )?.mainStep;

      switch (mainStep) {
        case "GuideStep":
          component = <GuideStep />;
          break;
        case "PersonalAddressDataStep":
          component = <PersonalAddressDataStep />;
          break;
        case "AcademicDegreeVocationalTraningStep":
          component = <AcademicDegreeVocationalTraningStep />;
          break;
        case "TermsDeclarationsStep":
          component = <TermsDeclarationsStep />;
          break;
        case "MedicoParceiroAttachmentDataStep":
          component = <MedicoParceiroAttachmentDataStep />;
          break;
        case "BusinessAddressDataStep":
          component = <BusinessAddressDataStep />;
          break;
        default:
          break;
      }

      setCurrentComponent(component);
    }
  }, [state.CurrentStep, state.Protocol, history]);

  return (
    <AppThemeRequestProvider>
      <Grid container>
        <Grid item xs={5}>
          <TmpSkeletonLeftPageCustom
            title={["Médico Parceiro"]}
            subTitle="Este formulário é destinado a médico especialista de outros estados convidados a fazer parte do programa." />
        </Grid>

        <Grid item xs={7}>
          <Grid item>
            <Box ml={4}>
              <Grid item>
                <StepDescription
                  currentStep={state.CurrentStep}
                  totalSteps={MedicoParceiroStepForm.length}
                ></StepDescription>
              </Grid>
            </Box>
            <Box ml={4}>{currentComponent}</Box>
          </Grid>

          <Grid item>
            {state.MessageErrorToGoStep.length > 0
              ? state.MessageErrorToGoStep.map((message, index) => (
                <div key={index}>
                  <Box mt={2} ml={4}>
                    <Alert severity="error">
                      <AlertTitle>Atenção</AlertTitle>
                      {message}
                    </Alert>
                  </Box>
                </div>
              ))
              : null}

            <Box ml={4} mt={2}>
              <Steps.StepButtons
                currentStep={state.CurrentStep}
                totalSteps={MedicoParceiroStepForm.length}
                isLoading={state.Loading}
                onNextClick={onNextClick}
                onBackClick={onToBackClick}
                onFinishClick={onToFinishClick}
              />
            </Box>
          </Grid>

          <Controls.ConfirmModal
            ref={modalRef}
            onConfirmClick={onConfirmModalClick}
            title="Confirmar a saída do formulário"
            message="Você tem certeza que deseja sair do formulário ? Todas as suas informações serão perdidas."
          />
        </Grid>
      </Grid>
    </AppThemeRequestProvider>
  );
}
